<highcharts-chart
  *ngIf="chartOptions"
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [callbackFunction]="getCallbackWithContext()"
  [style]="{'height': height}"
  [update]="update"
  (updateChange)="this.updateChangeEmitter($event)"
  class="block">
</highcharts-chart>
